var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "reminders" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "reminders_block_bg" }, [
      _c("div", { staticClass: "blk_header" }, [
        _c("div", { staticClass: "blk_title" }, [
          _vm._v(_vm._s(_vm.Lang.get("messages.reminders"))),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "reminders_items" },
        [
          !_vm.reminders.length
            ? _c("div", { staticClass: "reminder_item" }, [
                _c("h6", [
                  _vm._v(_vm._s(_vm.Lang.get("messages.no_reminders"))),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.reminders, function (reminder) {
            return _c(
              "div",
              { key: reminder.id, staticClass: "reminder_item" },
              [
                _c("h6", [_vm._v(_vm._s(reminder.type.name))]),
                _vm._v(" "),
                _c("div", { staticClass: "d-flex flex-wrap dates" }, [
                  _c("div", { staticClass: "badge" }, [
                    _vm._v(
                      _vm._s(_vm._f("date")(reminder.date, "DD MMMM, YYYY "))
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("p", [
                  _c("span", [_vm._v(" Class : ")]),
                  _vm._v(_vm._s(reminder.class.full_name)),
                ]),
                _vm._v(" "),
                _c("p", [
                  _c("span", [_vm._v(" Subject : ")]),
                  _vm._v(_vm._s(reminder.subject.name)),
                ]),
                _vm._v(" "),
                _c("h6", [_vm._v("Dont miss It")]),
              ]
            )
          }),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("button", { staticClass: "btn reminder_btn" }, [
      _c("img", {
        staticClass: "lazyload",
        attrs: {
          src: "assets/images/schedule.png",
          "data-src": "assets/images/schedule.png",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }